import { Link } from 'react-router-dom';
import FeeForm from './FeeForm'; // Create this component

const FeePaymentSection = () => (
    <div className="wd-negative-gap elementor-element elementor-element-7622a58 e-flex e-con-boxed e-con e-parent" data-id="7622a58" data-element_type="container">
        <div className="e-con-inner">
            <div className="elementor-element elementor-element-45a4015 e-con-full e-flex e-con e-child" data-id="45a4015" data-element_type="container">
                <div className="elementor-element elementor-element-94dd2b0 wd-width-100 elementor-widget elementor-widget-wd_title" data-id="94dd2b0" data-element_type="widget" data-widget_type="wd_title.default">
                    <div className="elementor-widget-container">
                        <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-default wd-title-style-default wd-title-size-default text-left">
                            <div className="title-subtitle subtitle-color-default subtitle-style-default wd-fontsize-xs">
                                Education Fees Payment<br />
                            </div>
                            <div className="liner-continer">
                                <h4 className="woodmart-title-container title wd-fontsize-l wd-underline-colored">Pay <u> Education Fees </u> Online with imw-edu</h4>
                            </div>
                            <div className="title-after_title reset-last-child wd-fontsize-xs">
                                <p>Education fees, also known as tuition fees or educational expenses, are the costs associated with enrolling in and attending an educational institution, such as a school, college, university, or other learning institution.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="elementor-element elementor-element-c4e25f9 elementor-widget elementor-widget-wd_button" data-id="c4e25f9" data-element_type="widget" data-widget_type="wd_button.default">
                    <div className="elementor-widget-container">
                        <div className="wd-button-wrapper text-left">
                            <Link className="btn btn-style-default btn-shape-rectangle btn-size-default btn-color-primary btn-icon-pos-right" to="/cart_checkout">
                                <span className="wd-btn-text">Read More</span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="elementor-element elementor-element-e15ac5a e-con-full e-flex e-con e-child" data-id="e15ac5a" data-element_type="container">
                <div className="elementor-element elementor-element-3749388 elementor-widget elementor-widget-shortcode" data-id="3749388" data-element_type="widget" data-widget_type="shortcode.default">
                    <div className="elementor-widget-container">
                        <div className="elementor-shortcode">
                           <FeeForm />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default FeePaymentSection;